import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';
import GenericCard from '../../../components/GenericCards/GenericCards';
import useMobile from '../../../hooks/useMobileHook';
import {
  openExternalLink,
} from '../../../utils/utils';

const Sharepoint = ({
  transperant = false,
  coveredFamilyMembers,
  isWaived = false,
  linksData,
}: any) => {
  const isMobile = useMobile();
  const navigate = useNavigate();

  return (
    <Row className="m-0 p-0 d-flex justify-content-between">
      
        <div className=''>
          <GenericCard
              onClick={() => openExternalLink('https://oneportal.uxgroup.com/LW60/AccessPoint/sharePoint.html')}
              className={'doc-upload p-5 cursor-pointer'}
              variant={'white'}>
              <div
                className={'carousel-img-container rounded-1 overflow-hidden'}>
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/${'company1.png'}`}
                  alt={`${process.env.PUBLIC_URL}/${'company1.png'}`}
                />
              </div>
              <div className="mt-4 lh-xs fw-light">
                <h6 className="mb-0 text-sm-16-lg-20">Documents & Reports</h6>
              </div>
              <div className="lh-xxs fw-light text-sub1 text-light-grey-normal">
                <span>Visit Sharepoint</span>
              </div>
            </GenericCard>
          </div>

    </Row>
  );
};

export default Sharepoint;
